import { ServerURL } from '../../config.js'

let subfolder = "contact"

export const Config = {
	server	: {
		"sendMessage"							: ServerURL+subfolder+"/sendMessage.php",
	}
}
